import { render, staticRenderFns } from "./mainOne.vue?vue&type=template&id=4b908db0&scoped=true&"
import script from "./mainOne.vue?vue&type=script&lang=js&"
export * from "./mainOne.vue?vue&type=script&lang=js&"
import style0 from "./mainOne.vue?vue&type=style&index=0&id=4b908db0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b908db0",
  null
  
)

export default component.exports